const currencyConfigs = {
  MXN: {
    locale: 'en',
    symbol: '$',
    config: {
      style: 'decimal'
    }
  },
  COP: {
    locale: 'es-CO',
    config: {
      style: 'decimal',
      maximumFractionDigits: 0
    }
  },
  CLP: {
    locale: 'es-CL',
    config: {
      style: 'decimal',
      maximumFractionDigits: 0
    }
  }
}

export default {
  methods: {
    /**
    * return localized currency value
    * @param {Number} value float value
    * @param {string} locale language code
    * @param {string} currency Currency ISO Code
    * @return {string} formated value
    */
    currencyIntl (currency, value) {
      const routes = [
        this.$routeResolver('routes.member-get-member'),
        this.$routeResolver('routes.customer.wallet'),
        this.$routeResolver('routes.search.list'),
        this.$routeResolver('routes.booking.configure'),
        this.$routeResolver('routes.booking.identification'),
        this.$routeResolver('routes.booking.payment'),
        this.$routeResolver('routes.booking.payment.insurance')
      ]

      if (
        Object.keys(currencyConfigs).includes(currency) &&
        routes.includes(this.$route.name)
      ) {
        const currentCurrency = currencyConfigs[currency]
        const currentSymbol = currentCurrency.symbol ? currentCurrency.symbol : ''

        return `${currency}${currentSymbol} ` + (new Intl.NumberFormat(
          currentCurrency.locale,
          {
            ...currentCurrency.config,
            currency
          }
        ).format(value))
      }

      return new Intl.NumberFormat(
        this.$i18n.locale,
        {
          style: 'currency',
          currency
        }
      ).format(value)
    },
    /**
    * return localized currency value
    * @param {number} value float value
    * @param {string} currency Currency ISO Code
    * @return {string} formated value
    */
    numberIntl(value, minimumFractionDigits = 0) {
      return new Intl.NumberFormat(
        this.$i18n.locale,
        {
          style: 'decimal',
          minimumFractionDigits
        }
      ).format(value)
    },

    /**
    * return localized currency iso code
    * @param {string} locale
    * @param {string} currency Currency ISO Code
    * @return {string} formated value
    */
    currencyIsoCode(currency, locale) {
      return (0).toLocaleString(
        locale,
        {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }
      ).replace(/\d/g, '').trim()
    },
    /**
    * Função que formata a moeda com base no locale
    * @param {number} value
    * @param {string} currency
    * @param {string} locale
    * @param {boolean} initialValue
    */
    formatCurrency(value, currency, locale, initialValue = false) {
      if (value || (initialValue && currency)) {
        if (currency === 'MXN' &&
          ['booking_results', 'booking_configure', 'booking_payment', 'booking_confirmation'].includes(window.ROUTE_NAME)) {
          return `${currency}$ ` + (new Intl.NumberFormat(
            'en',
            {
              style: 'decimal',
              currency: currency
            }
          ).format(value))
        }
        return new Intl.NumberFormat(
          locale,
          {
            style: 'currency',
            currency: currency
          }
        ).format(value)
      } else {
        return ''
      }
    }
  }
}
